import { useEffect, useState } from "react";
import axios from "axios";
import { caseTransformingAxios } from "@shared/v2/caseTransformingAxios";

const DELETE_FALLBACK_ERROR = "Something went wrong. Please try again.";

const useSources = () => {
  const [error, setError] = useState(null);
  const [deleteError, setDeleteError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sources, setSources] = useState([]);

  useEffect(() => {
    setLoading(true);
    const abortController = new AbortController();

    caseTransformingAxios
      .get("/source_settings.json", { signal: abortController.signal })
      .then((res) => {
        setSources(res.data.data.map((s) => s.attributes));
        setLoading(false);
      })
      .catch((err) => {
        if (axios.isCancel(err)) return;
        console.error(err);
        setLoading(false);
      });

    return () => abortController.abort();
  }, []);

  return {
    actions: {
      addSource: (source) =>
        caseTransformingAxios
          .post("/source_settings", source)
          .then((res) => {
            setSources((prev) => [...prev, res.data.data.attributes]);
          })
          .catch((err) => {
            setError(err.response?.data);
          }),
      toggleSource: (source) =>
        caseTransformingAxios
          .patch(`/source_settings/${source.id}`, {
            hidden: !source.hidden,
          })
          .then(() => {
            setSources((prev) => prev.map((s) => (s.id === source.id ? { ...s, hidden: !s.hidden } : s)));
          })
          .catch((err) => {
            console.error(err);
          }),
      // Resolves to whether the source was actually deleted, so the caller can
      // keep the confirmation open when the request is rejected.
      deleteSource: (source) =>
        caseTransformingAxios
          .delete(`/source_settings/${source.id}`)
          .then(() => {
            setSources((prev) => prev.filter((s) => s.id !== source.id));
            setDeleteError(null);
            return true;
          })
          .catch((err) => {
            setDeleteError(err.response?.data?.errors?.[0] || DELETE_FALLBACK_ERROR);
            return false;
          }),
      clearDeleteError: () => setDeleteError(null),
    },
    deleteError,
    error,
    loading,
    sources,
  };
};

export default useSources;
